import {Box, Center, Spinner, Text} from '@chakra-ui/react';
import {useTranslation} from 'hooks';
import React from 'react';
import {colors} from 'theme';
import NextImageUI from 'ui/NextImage';

type Props = {
  isLoading: boolean;
};

export const EmptyCards = ({isLoading}: Props) => {
  const {t} = useTranslation();

  return (
    <Center>
      <Box textAlign="center">
        {isLoading ? (
          <Spinner color={colors.pink} />
        ) : (
          <Center pt={[0, '30px']}>
            <Box justifyItems="center">
              <NextImageUI src="/emptyCards.svg" width={200} height={200} alt="No cards" />
              <Text as="h2" textAlign="center">
                {t('noCards')}
              </Text>
            </Box>
          </Center>
        )}
      </Box>
    </Center>
  );
};
